export const MAX_VISIBLE_AVATARS = 4;
